var React = require('react');

function Map (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M192 32l192 64v384l-192-64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 117.66V464a16 16 0 0 0 21.94 14.86L160 416V32L20.12 88A32 32 0 0 0 0 117.66zm554.06-84.5L416 96v384l139.88-55.95A32 32 0 0 0 576 394.34V48a16 16 0 0 0-21.94-14.84z","className":"fa-primary","key":2})]);
}

Map.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Map;

Map.default = Map;
